module.exports = __webpack_public_path__ + "static/media/karavs.92c7f075.svg";